import React, { Component } from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColumnMenu, GridToolbar } from '@mui/x-data-grid';
import { green, red } from '@mui/material/colors';
// import { frFR } from '@mui/x-data-grid/locales'; // not working

const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'firstName',
    headerName: 'First name',
    width: 150,
    // editable: true,
  },
  {
    field: 'lastName',
    headerName: 'Last name',
    width: 150,
    // editable: true,
  },
  {
    field: 'age',
    headerName: 'Age',
    type: 'number',
    width: 110,
    // editable: true,
  },
  {
    field: 'fullName',
    headerName: 'Full name',
    description: 'This column has a value getter and is not sortable.',
    sortable: false,
    width: 160,
    valueGetter: (params) =>
      `${params.row.firstName || ''} ${params.row.lastName || ''}`,
  },
];

const rows = [
  { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
  { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
  { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
  { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
  { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
  { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
  { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
  { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
  { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
];

function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        components={{
          // Hide `ColumnMenuColumnsItem`
          ColumnMenuColumnsItem: null,
          ColumnMenuSortItem: null,
        }}
      />
    );
  }

const getRowClassName = (row, general, props) => {
    // const value = params.getValue(params.id, 'equipement_available');
    if(props.getRowStyle) {
      return props.getRowStyle(row)
    } else if (row.type = "demand_loan") {
        if (row.demand_status == "DEMAND_VALIDATE") {
          return 'equip-resa';
        } else if (row.demand_status == "DEMAND_READY") {
          return 'available-row';
        }

    } else {
      if (row.equipement_quantity > 1 && general) {
        return 'multiple-row';
      } else if (row.equipement_available === false) {
        return 'not-available-row';
      } else if (row.equipement_available === true) {
        return 'available-row';
      }

    }
    return '';
};

const OPERATOR = {
	equals: "=",
	"isNotEmpty": "!= ''",
	"isEmpty": "= ''",
}
const OPERATOR_CONTAINS = {
	contains: "+.*",
	startsWith: "^",
	endsWith: "$",
	// contains: "REGEXP_CONTAINS(lower(field), lower(value+.*))",
	// startsWith: "REGEXP_CONTAINS(lower(equipement_brand), lower(^value))",
	// endsWith: "REGEXP_CONTAINS(lower(equipement_brand), lower(value$))",
}
class TableWithFilters extends Component {
    state = {  }

	formatQuery = (operator, value) => {
		let regexVal = (operator == "startsWith" ? "^"+value : value+OPERATOR_CONTAINS[operator] )
		return regexVal
	}
    onFilterChange = (filterModel) => {
        // Here you save the data you need from the filter model
        // this.setState({ filterModel: { ...filterModel } });
        console.log('====================================');
        console.log({filterModel});
        console.log('====================================');
      //   {
      //     "items": [
      //         {
      //             "field": "equipement_name",
      //             "operator": "equals",
      //             "id": 32211,
      //             "value": "54"
      //         }
      //     ],
      //     "logicOperator": "and",
      //     "quickFilterValues": [
      //         "ikea"
      //     ],
      //     "quickFilterLogicOperator": "and"
      // }
		let queries = []
		filterModel.items.forEach(q => {
			if(Object.keys(OPERATOR).includes(q.operator)){
				queries.push(`lower(${q.field}) ${OPERATOR[q.operator]} lower('${q.value}')`)
			} else if(Object.keys(OPERATOR_CONTAINS).includes(q.operator)){
				let searchVal = this.formatQuery(q.operator, q.value)
				queries.push(`REGEXP_CONTAINS(lower(${q.field}), lower('${searchVal}'))`)
			}
		})
		console.log('====================================');
		console.log({queries});
		console.log('====================================');	
		this.props.filterList(queries.join(" AND "))
    }
  
    render() {
        return (
            <Box p={1}>
                <DataGrid
                    rows={this.props.rows}
                    columns={this.props.columns}
                    getRowId={(row) => row[this.props.internalId]}
                    initialState={{
                      // ...data.initialState,
                      pagination: { paginationModel: { pageSize: 25 } },
                    }}
                    pageSizeOptions={[25, 50, 100]}
                    // checkboxSelection
                    disableSelectionOnClick
                    localeText={frFRGrid}
                    experimentalFeatures={{ newEditingApi: true }}
                    components={{ 
                        Toolbar: GridToolbar,
                        // ColumnMenu: CustomColumnMenu 
                    }}
                    autoHeight
                    rowHeight={this.props.rowHeight || 100}
                    disableColumnMenu
                    disableDensitySelector
                    // disableColumnSelector
                    rowSelection={false}
                    componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 300 },
                        },
                    }}
                    getRowClassName={(params) => getRowClassName(params.row, this.props.general, this.props)}
                    // getRowStyle={this.props.getRowStyle}
                    // filterMode="server"
                    // onFilterModelChange={this.onFilterChange}
                />
            </Box>
        );
    }
}


export default TableWithFilters;

const frFRGrid = {
    // Root
    noRowsLabel: 'Pas de résultats',
    noResultsOverlayLabel: 'Aucun résultat.',
    // Density selector toolbar button text
    toolbarDensity: 'Densité',
    toolbarDensityLabel: 'Densité',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Confortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Colonnes',
    toolbarColumnsLabel: 'Choisir les colonnes',
    // Filters toolbar button text
    toolbarFilters: 'Filtres',
    toolbarFiltersLabel: 'Afficher les filtres',
    toolbarFiltersTooltipHide: 'Cacher les filtres',
    toolbarFiltersTooltipShow: 'Afficher les filtres',
    toolbarFiltersTooltipActive: count => count > 1 ? `${count} filtres actifs` : `${count} filtre actif`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: 'Recherche…',
    toolbarQuickFilterLabel: 'Recherche',
    toolbarQuickFilterDeleteIconLabel: 'Supprimer',
    // Export selector toolbar button text
    toolbarExport: 'Exporter',
    toolbarExportLabel: 'Exporter',
    toolbarExportCSV: 'Télécharger en CSV',
    toolbarExportPrint: 'Imprimer',
    toolbarExportExcel: 'Télécharger pour Excel',
    // Columns panel text
    columnsPanelTextFieldLabel: 'Chercher colonne',
    columnsPanelTextFieldPlaceholder: 'Titre de la colonne',
    columnsPanelDragIconLabel: 'Réorganiser la colonne',
    columnsPanelShowAllButton: 'Tout afficher',
    columnsPanelHideAllButton: 'Tout cacher',
    // Filter panel text
    filterPanelAddFilter: 'Ajouter un filtre',
    filterPanelDeleteIconLabel: 'Supprimer',
    filterPanelLogicOperator: 'Opérateur logique',
    filterPanelOperator: 'Opérateur',
    filterPanelOperatorAnd: 'Et',
    filterPanelOperatorOr: 'Ou',
    filterPanelColumns: 'Colonnes',
    filterPanelInputLabel: 'Valeur',
    filterPanelInputPlaceholder: 'Filtrer la valeur',
    // Filter operators text
    filterOperatorContains: 'contient',
    filterOperatorEquals: 'égal à',
    filterOperatorStartsWith: 'commence par',
    filterOperatorEndsWith: 'se termine par',
    filterOperatorIs: 'est',
    filterOperatorNot: "n'est pas",
    filterOperatorAfter: 'postérieur',
    filterOperatorOnOrAfter: 'égal ou postérieur',
    filterOperatorBefore: 'antérieur',
    filterOperatorOnOrBefore: 'égal ou antérieur',
    filterOperatorIsEmpty: 'est vide',
    filterOperatorIsNotEmpty: "n'est pas vide",
    filterOperatorIsAnyOf: 'fait partie de',
    // Filter values text
    filterValueAny: 'tous',
    filterValueTrue: 'vrai',
    filterValueFalse: 'faux',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Afficher les colonnes',
    // columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filtrer',
    columnMenuHideColumn: 'Cacher',
    columnMenuUnsort: 'Annuler le tri',
    columnMenuSortAsc: 'Tri ascendant',
    columnMenuSortDesc: 'Tri descendant',
    // Column header text
    columnHeaderFiltersTooltipActive: count => count > 1 ? `${count} filtres actifs` : `${count} filtre actif`,
    columnHeaderFiltersLabel: 'Afficher les filtres',
    columnHeaderSortIconLabel: 'Trier',
    // Rows selected footer text
    footerRowSelected: count => count > 1 ? `${count.toLocaleString()} lignes sélectionnées` : `${count.toLocaleString()} ligne sélectionnée`,
    // Total row amount footer text
    footerTotalRows: 'Lignes totales :',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount) => `${visibleCount.toLocaleString()} sur ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Sélection',
    checkboxSelectionSelectAllRows: 'Sélectionner toutes les lignes',
    checkboxSelectionUnselectAllRows: 'Désélectionner toutes les lignes',
    checkboxSelectionSelectRow: 'Sélectionner la ligne',
    checkboxSelectionUnselectRow: 'Désélectionner la ligne',
    // Boolean cell text
    booleanCellTrueLabel: 'vrai',
    booleanCellFalseLabel: 'faux',
    // Actions cell more text
    actionsCellMore: 'Plus',
    // Column pinning text
    pinToLeft: 'Épingler à gauche',
    pinToRight: 'Épingler à droite',
    unpin: 'Désépingler',
    // Tree Data
    treeDataGroupingHeaderName: 'Groupe',
    treeDataExpand: 'afficher les enfants',
    treeDataCollapse: 'masquer les enfants',
    // Grouping columns
    groupingColumnHeaderName: 'Groupe',
    groupColumn: name => `Grouper par ${name}`,
    unGroupColumn: name => `Arrêter de grouper par ${name}`,
    // Master/detail
    detailPanelToggle: 'Afficher/masquer les détails',
    expandDetailPanel: 'Afficher',
    collapseDetailPanel: 'Masquer',
    // Row reordering text
    rowReorderingHeaderName: 'Positionnement des lignes'
  
    // Aggregation
    // aggregationMenuItemHeader: 'Aggregation',
    // aggregationFunctionLabelSum: 'sum',
    // aggregationFunctionLabelAvg: 'avg',
    // aggregationFunctionLabelMin: 'min',
    // aggregationFunctionLabelMax: 'max',
    // aggregationFunctionLabelSize: 'size',
  };